import { Model, IModel } from '@common/models/Model';

export interface IVisitConsentClientModel extends IModel {
  isCurrentlyOnMedications: boolean | undefined;
  medicationList: string;
  optInToAudioRecording: boolean | undefined;
  previousTreatment: string;
  reasonForVisit: string;
  treatmentStarted: boolean | undefined;
  visitConsentClientId: number;
}

export class VisitConsentClientModel
  extends Model
  implements Record<keyof IVisitConsentClientModel, any>
{
  isCurrentlyOnMedications: boolean | undefined;
  medicationList: string;
  optInToAudioRecording: boolean | undefined;
  previousTreatment: string;
  reasonForVisit: string;
  treatmentStarted: boolean | undefined;
  visitConsentClientId: number;

  constructor(params?: Partial<IVisitConsentClientModel>) {
    super(params);
    this.isCurrentlyOnMedications = params?.isCurrentlyOnMedications;
    this.medicationList = _.defaultTo(params?.medicationList, '');
    this.optInToAudioRecording = params?.optInToAudioRecording;
    this.previousTreatment = _.defaultTo(params?.previousTreatment, '');
    this.reasonForVisit = _.defaultTo(params?.reasonForVisit, '');
    this.visitConsentClientId = _.defaultTo(params?.visitConsentClientId, 0);
  }
}
